import cn from 'clsx';
import React, { type FC, type PropsWithChildren, memo, forwardRef, type MutableRefObject, type Ref } from 'react';
import TooltipQuestionMark from '../../../../assets/img/tooltip-question-mark.svg?url';
import BlueInfoCircle from '../../../../assets/img/blue-info-circle.svg?url';
import { DH } from '../../../../utils/DataHook';
import { useTheme } from '../../../../contexts/Theme';
import s from './styles.scss';

export const Container: FC<PropsWithChildren<{}>> = memo((props) => (
  <div data-hook={DH.Field.Container.CVV} className={s.cardCvvField}>
    {props.children}
  </div>
));
Container.displayName = 'Container';

export const CVVHintButton: FC<{
  onMouseOver(): void;
  onMouseOut(): void;
  onClick(): void;
  ref: Ref<HTMLButtonElement>;
}> = memo(
  forwardRef((props, ref: MutableRefObject<HTMLButtonElement>) => {
    const theme = useTheme();
    const imgSrc = theme === 'wsr-like' ? BlueInfoCircle : TooltipQuestionMark;
    return (
      <button
        data-hook={DH.Field.CVVHint.Button}
        className={s.cvvHelpIcon}
        onMouseOver={(e) => {
          if (!ref.current.contains(e.relatedTarget as HTMLElement)) {
            props.onMouseOver();
          }
        }}
        onMouseOut={(e) => {
          if (!ref.current.contains(e.relatedTarget as HTMLElement)) {
            props.onMouseOut();
          }
        }}
        onClick={() => props.onClick()}
        ref={ref}
      >
        <img data-hook={DH.Field.CVVHint.ButtonIcon} src={imgSrc} aria-labelledby="cvv-help-text-default" alt="CVV" />
      </button>
    );
  }),
);
CVVHintButton.displayName = 'CVVHintButton';

export const CVVImage: FC<{
  src: string;
  fillSize?: boolean;

  onClick?(): void;
}> = memo((props) => (
  <img
    data-hook={DH.Field.CVVHint.Image}
    className={cn(s.cvvImage, {
      [s.fillSize]: props.fillSize,
    })}
    src={props.src}
    alt="CVV"
    onClick={props.onClick}
  />
));
CVVImage.displayName = 'CVVImage';

export const CVVImageRedesign: FC<{
  src: string;
  fillSize?: boolean;

  onClick?(): void;
}> = memo((props) => <img data-hook={DH.Field.CVVHint.Image} src={props.src} alt="CVV" onClick={props.onClick} />);

CVVImageRedesign.displayName = 'CVVImageRedesign';
